import { EquipmentType } from '@/constants';

/**
 * @desc 获取页码
 */
export function getPages(obj) {
    let dqPage = obj.current,//得到当前页数
        pageCount = obj.count,//得到总页数
        i = 1,
        item=[];

    if (pageCount <= 3 ) {//总页数小于五页，则加载所有页
        
        for (i; i <= pageCount; i++) {
            item.push(i);
        };
        return item;
    }else if (pageCount > 3) {//总页数大于五页，则加载五页
        if (dqPage < 3) {//当前页小于5，加载1-5页
            for (i; i <= 3; i++) {
                item.push(i)
            };
            return item;
        }else if (dqPage >= 3) {//当前页大于5页
            if (dqPage+1 == pageCount) {//当前页+1等于总页码
                for(i = dqPage-1; i <= pageCount; i++){//“...”后面跟三个页码当前页居中显示
                   item.push(i)
                }
            }else if (dqPage == pageCount) {//当前页数等于总页数则是最后一页页码显示在最后
                for(i = dqPage-2; i <= pageCount; i++){//...后面跟三个页码当前页居中显示
                   item.push(i)
                }
            }else{//当前页小于总页数，则最后一页后面跟...
                for(i = dqPage-1; i <= dqPage+1; i++){//dqPage+1页后面...
                   item.push(i);
                }
            }
            return item;
        }
    }
}

/**
 * @desc 时间格式化
 */
export function format(date) {
    const year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let hour = date.getHours()
    let minute = date.getMinutes()
    let seconds = date.getSeconds()
  
    if (month < 10) {
      month = '0' + month
    }
  
    if (day < 10) {
      day = '0' + day
    }
  
    if (hour < 10) {
      hour = '0' + hour
    }
  
    if (minute < 10) {
      minute = '0' + minute
    }
  
    if (seconds < 10) {
      seconds = '0' + seconds
    }
    return year + '-' + month + '-' + day + '   ' + hour + ':' + minute + ':' + seconds
}

/**
 * @desc 获取动态大类
 */
export function returnContentType(type,typeOptions) {
    const index = typeOptions.findIndex(item => {
        return item.value == type
    })

    if (index !== -1) {
        return typeOptions[index].label
    } else {
        return ''
    }
}

//获取当前设备类型
export function getComAgentData() {
    let data = {
        type: EquipmentType.PC,
    }
    let sUserAgent = navigator.userAgent;
    if (sUserAgent.indexOf('Android') > -1 && sUserAgent.indexOf('Mobile') > -1 || sUserAgent.indexOf('iPhone') > -
      1 ||
      sUserAgent.indexOf('iPod') > -1 || sUserAgent.indexOf('Symbian') > -1 || sUserAgent.indexOf('IEMobile') > -1
    ) {
      data.type = EquipmentType.MOBILE;
    }

    return data;
}
  